import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d89cb62"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-radio__inner" }, null, -1))
const _hoisted_2 = ["value", "name", "disabled"]
const _hoisted_3 = { class: "el-radio__label" }
const _hoisted_4 = {
  key: 0,
  class: "item__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['radio-wrap', { 'is-horizontal': _ctx.isHorizontal }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (x, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("label", {
            class: _normalizeClass(["el-radio mr-2", [
          _ctx.border && _ctx.size ? 'el-radio--' + _ctx.size : '',
          { 'is-disabled': x.disabled },
          { 'is-focus': _ctx.model === x.value },
          { 'is-bordered mb-2': _ctx.border }
        ]]),
            role: "radio"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["el-radio__input", {
            'is-disabled': x.disabled,
            'is-checked': _ctx.model === x.value
          }])
            }, [
              _hoisted_1,
              _withDirectives(_createElementVNode("input", {
                ref_for: true,
                ref: "radio",
                class: "el-radio__original",
                value: x.value,
                type: "radio",
                "aria-hidden": "true",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
                name: _ctx.name,
                disabled: x.disabled,
                tabindex: "-1"
              }, null, 8, _hoisted_2), [
                [_vModelRadio, _ctx.model]
              ])
            ], 2),
            _createElementVNode("span", _hoisted_3, _toDisplayString(x.label), 1)
          ], 2)
        ]))
      }), 128))
    ], 2),
    (_ctx.errors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errors[0]), 1))
      : _createCommentVNode("", true)
  ], 64))
}